import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterLogic extends Component {
  get SELECTORS() {
    return {
      form: '.js-newsletter-form',
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.$on('submit.newsletter', this.subscribeToNewsletter, 'body', this.SELECTORS.form, this);
  }

  subscribeToNewsletter(e) {
    const ctx = e.event.data;
    e.event.preventDefault();
    let $this = $(e.event.currentTarget);
    let url = $this.attr('action');
    let $submit = $this.find('.js-nl-submission');
    let emailval = $this.find('input[name=email]').val();

    if ($this.parents('.modal').length) {
      $this.attr('action', $this.attr('action') + '?xhr=true');
    }

    ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
      button: $submit,
    });

    ctx
      .$doAjax({
        type: 'POST',
        url: url,
        data: $this.serialize()
      })
      .done(html => {
        ctx.log('Newsletter modal success...');
        let error = $(html).find('span.error').length > 0;
        let alreadySubcribed = $(html).find('div.form-error').length > 0;
        let doRegister = $this.data('registerUrl') != null && $this.data('registerUrl').length > 0;
        let isLogged = $this.data('loggedin');
        let isFidelityRegister = $this.data('fidelityRegister');
        let $newContent = $(html).find('.js-modal-form-contents')
        $this.closest('.js-modal-form-contents').replaceWith($(html).find('.js-modal-form-contents'));
        if(!error && !alreadySubcribed) {
          let trackingComponent = new TrackingComponent();
          trackingComponent.actions.newsletterSubscribe($submit[0].dataset);
        }
        if(isFidelityRegister && !error) {
          let newsletterForm = $(document).find('#newsletterForm');
          let titleBox = $(newsletterForm).find("article");
          titleBox.addClass("d-none");
        }

        if (!isLogged && !error && $newContent.data('register') && doRegister) {
          //TODO
          ctx
            .$doAjax({
              url: `${$this.data('registerUrl')}`,
              data: {
                email: emailval,
                afterNewsletter: true
              },
            })
            .done(resp => {
              ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                unsafeContent: resp,
                canScroll: true
              });
              ctx.importComponent("RegistrationComponent");
              ctx.$emit(ctx.$customEvents.VALIDATION.bindValidation);
              //ctx.log(resp);
            })
            .fail(xhr => {
              ctx.log(xhr);
            })
            .always(() => {
              ctx.log('done');
            });

          Cookies.set(ctx.hideCookieKey, 'true', {
            expires: 365,
            path: '/'
          });
        }
      })
      .fail(xhr => {
        console.log(`nl submit error:  ${$this.serialize()}`);
        console.log(xhr);
      })
      .always(() => {
        ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
          button: $submit,
        });
      });
  }

  render() {
    this.bindEvents();
  }
}
